import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule} from '@angular/common/http';
import {RouterModule} from '@angular/router';
import {LoadingComponent} from '../tools/loading/loading.component';
import {AvatarComponent, SearchFieldComponent, SpinnerComponent} from '../components';

const components = [
  AvatarComponent,
  LoadingComponent,
  SearchFieldComponent,
  SpinnerComponent
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    RouterModule,
  ],
  declarations: [
    ...components,
  ],
  exports: [
    components,
  ]
})
export class SharedModule {
}
